import { render } from "./SupportHomePage.vue?vue&type=template&id=258a8550&scoped=true"
import script from "./SupportHomePage.vue?vue&type=script&lang=js"
export * from "./SupportHomePage.vue?vue&type=script&lang=js"

import "./SupportHomePage.vue?vue&type=style&index=0&id=258a8550&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258a8550"]])

export default __exports__